export default class AreaKeyItem {
  id: string;

  description: string;

  active: boolean;

  junior: string;

  plain: string;

  senior: string;

  isApproved: boolean | null;

  observation: string;

  loadingDelete: boolean = false;

  loadingApprove: boolean = false;

  loadingReject: boolean = false;

  loadingObservation: boolean = false;

  expanded: number | null = null;

  isNew: boolean = false;

  idTemporary: string | null = null

  constructor(obj: any = {}) {
    this.id = obj.id || null;
    this.description = obj.description || '';
    this.active = obj.active === undefined ? true : obj.active;
    this.junior = obj.junior || 'NOVICE';
    this.plain = obj.plain || 'NOVICE';
    this.senior = obj.senior || 'NOVICE';
    this.isApproved = obj.isApproved;
    this.observation = obj.observation || '';
    this.expanded = obj.expanded;
    this.isNew = obj.isNew || false;
    this.idTemporary = obj.idTemporary || null;
  }

  public static ofNew(): AreaKeyItem {
    return new AreaKeyItem(
      {
        isNew: true,
        expanded: 0,
        active: true,
        isApproved: null,
        idTemporary: new Date().getTime().toString(),
      },
    );
  }
}
